import { getIn } from 'seamless-immutable';
import { getCurrentSku } from '@catalogo/core-sku';
import { productQtyVar } from '@catalogo/core-graphql-cache';
import config from '@catalogo/core-configuration/config/out/config.server.json';
import { getProductPage } from '../queries/product-page.graphql';

const ftmProductImage = product => getIn(product, ['images', '0', 'large'], '');

const getLasaOffer = (currentSku, product) => {
  const skuId = getIn(currentSku, ['id'], '').toString();
  const offers = getIn(product, ['lasa', 'result']) || [];
  const offer = offers.find(({ sku }) => sku === skuId);

  return offer;
};

export const getProduct = ({ client, id, parsedQs, routeId }) => {
  try {
    const path = `/produto/${id}`;
    const sellerId = getIn(parsedQs, ['sellerId'], '');
    const offerId = getIn(parsedQs, ['offerId'], '');
    const data = client.readQuery({
      query: getProductPage,
      variables: {
        productId: id,
        routeId,
        path,
        sellerId,
        brandCardId: config.brandCardId,
        offerId,
        hasOfferId: !!offerId,
        hasProductServices: config?.brand === 'acom',
      },
    });
    const { product } = data;
    const { name, video, categories, attributes, isPreSale } = product;
    const image = ftmProductImage(product);
    const sku = getCurrentSku({ product }, parsedQs);
    const offer = getIn(sku, ['offers', 'result', '0']);
    const isO2O = getIn(offer, ['seller', 'id']) === '33014556000196';
    const lasaOffer = isO2O ? offer : getLasaOffer(sku, product);
    const meta = getIn(sku, ['offers', 'meta']);

    return {
      name,
      image,
      video,
      sku,
      offer: { ...offer, name, meta },
      lasaOffer: { ...lasaOffer, name },
      isO2O,
      categories,
      attributes,
      isPreSale,
    };
  } catch (e) {
    return null;
  }
};

export const setProductQty = newQty => {
  productQtyVar(newQty);
};
